"use client";

import { useQuery } from "@tanstack/react-query";
import { publicSettingsQuery } from "./art-catalogue-enabled";

/**
 * Whether gift cards are on sale — the `giftCardsEnabled` row in the
 * `setting` table, thrown from admin → Nastavitve.
 *
 * Here it hides the menu entry. The /darilni-bon page checks the same
 * setting on the server and answers 404 while it is off, and the backend
 * refuses POST /gift-card/orders with 403 GIFT_CARDS_DISABLED, which is the
 * part that actually stops a sale. A card already sold keeps working either
 * way: the switch stops selling, not redeeming.
 *
 * FALSE while loading or on error, for the same reason as the art catalogue:
 * an entry that flashes in and out on every cold load is worse than one that
 * appears a moment late.
 */
export function useGiftCardsEnabled(): boolean {
  const { data } = useQuery(publicSettingsQuery);
  return data?.giftCardsEnabled === true;
}

/**
 * Whether a gift card can be redeemed at checkout — `giftCardsRedeemable` on
 * GET /setting/public, which the backend computes rather than stores: true
 * while sales are on, OR while any sold card still has money on it (not
 * void). It gates the "Imam darilni bon" field, and is deliberately NOT
 * `giftCardsEnabled`: switching sales off must not strand the cards already
 * out there.
 *
 * FALSE while loading or on error: a code field that appears a moment late
 * is better than one offered on a shop that has never sold a card.
 */
export function useGiftCardsRedeemable(): boolean {
  const { data } = useQuery(publicSettingsQuery);
  return data?.giftCardsRedeemable === true;
}
